module.exports = fox._r("images/sprite-small-preloader-white.png", __webpack_public_path__ + "images/sprite-small-preloader-white.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/sprite-small-preloader-white.png
// module id = 380
// module chunks = 4